import { useMutation } from '@apollo/client'
import { EditPriceVariables, EditCompany } from '../../types'
import { EDIT_COMPANY_PRICE } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useEditCompanyPrice = ({ onCompleted }: Props) =>
  useMutation<EditCompany, EditPriceVariables>(EDIT_COMPANY_PRICE, { onCompleted })
